import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift, ArrowRight, Star, Target, Coffee } from 'lucide-react';
export function IncludesSection() {
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  const staggerContainer = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  return <section className="py-24 bg-stone-50 overflow-hidden" data-id="element-132">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-133">
        {/* Intro Block */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="max-w-3xl mx-auto text-center mb-20" data-id="element-134">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-8" data-id="element-135">
            Lo que viene incluido{' '}
            <span className="text-emerald-600" data-id="element-136">(sin costo extra)</span>
          </h2>
          <div className="space-y-4 text-lg text-stone-700 text-left md:text-center bg-white p-8 rounded-2xl shadow-sm border border-stone-100" data-id="element-137">
            <p className="font-semibold text-xl text-stone-900" data-id="element-138">
              Pero eso no es todo.
            </p>
            <p data-id="element-139">
              Cuando decidís empezar tu Rutina Vital hoy, no solo recibís el
              Protocolo Anti-Inflamación de 30 días.
            </p>
            <p data-id="element-140">
              Agregamos diseñados para que no te quedes trabado en ningún punto
              del camino.
            </p>
            <p data-id="element-141">
              Porque la diferencia entre alguien que ve resultados y alguien que
              abandona en la semana 2 no es la información.
            </p>
            <p className="font-semibold text-emerald-700 bg-emerald-50 inline-block px-4 py-2 rounded-lg mt-2" data-id="element-142">
              Es el soporte práctico que recibe mientras implementa.
            </p>
          </div>
        </motion.div>

        {/* Bonuses */}
        <div className="space-y-16 mb-24" data-id="element-143">
          {/* BONO 1 */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={fadeIn} className="bg-white rounded-3xl overflow-hidden shadow-md border border-stone-200 flex flex-col" data-id="element-144">
            <div className="bg-stone-100 flex items-center justify-center p-8 md:p-12 border-b border-stone-200" data-id="element-145">
              <img src="https://cdn.magicpatterns.com/uploads/1o4qCRkVYCNtny77tvrQh8/BONO_1.png" alt="Menú Anti-Inflamación Express" className="w-full max-w-md object-contain drop-shadow-xl" data-id="element-146" />
            </div>
            <div className="p-8 md:p-10 flex flex-col justify-center" data-id="element-147">
              <div className="flex items-center gap-2 mb-4" data-id="element-148">
                <Gift className="w-5 h-5 text-emerald-600" data-id="element-149" />
                <span className="text-sm font-bold tracking-wider text-emerald-600 uppercase" data-id="element-150">
                  Bono #1
                </span>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-stone-900 mb-2" data-id="element-151">
                Menú Anti-Inflamación Express (15 Min)
              </h3>
              <div className="flex items-center gap-3 mb-6 pb-6 border-b border-stone-100" data-id="element-152">
                <span className="text-stone-500 line-through" data-id="element-153">
                  Valor real: $50.000 ARS
                </span>
                <span className="bg-emerald-100 text-emerald-800 font-bold px-3 py-1 rounded-full text-sm" data-id="element-154">
                  Hoy: GRATIS
                </span>
              </div>

              <div className="space-y-4 text-stone-600 mb-8" data-id="element-155">
                <p data-id="element-156">
                  ¿Sabés cuál es el momento exacto en que la mayoría abandona un
                  protocolo de alimentación?
                </p>
                <p data-id="element-157">
                  No es cuando no ven resultados. Es cuando abren la heladera,
                  no saben qué cocinar y terminan comiendo lo primero que
                  encuentran.
                </p>
                <p data-id="element-158">
                  El Menú Anti-Inflamación Express existe para que eso no te
                  pase. Es un recetario táctico con 21 comidas listas en 15
                  minutos (o menos), armadas específicamente para no disparar
                  inflamación, pensadas para ingredientes reales que encontrás
                  en cualquier súper argentino.
                </p>
                <p data-id="element-159">
                  Sin recetas de 40 pasos. Sin ingredientes imposibles. Sin
                  pasar horas en la cocina.
                </p>
              </div>

              <div className="mb-8" data-id="element-160">
                <h4 className="font-bold text-stone-900 mb-4 flex items-center gap-2" data-id="element-161">
                  <Star className="w-5 h-5 text-emerald-500" data-id="element-162" />
                  Lo que incluye:
                </h4>
                <ul className="space-y-3" data-id="element-163">
                  {['21 comidas express (7 desayunos / 7 almuerzos / 7 cenas)', "El 'Combinador 3x3': armá un plato anti-inflamatorio en 30 segundos", "5 'cenas de emergencia' para cuando no hay ganas de nada", 'Swaps inteligentes (cuando hay antojo o estás fuera de casa)', 'Batch de 45 minutos: cocinás una vez, comés bien toda la semana', "Checklist 'Despensa Express' para no improvisar en el súper", '2 semanas de ejemplo (minimalista y variada)'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-164">
                      <CheckCircle2 className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-165" />
                      <span className="text-stone-700" data-id="element-166">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="bg-stone-50 p-5 rounded-xl border border-stone-200" data-id="element-167">
                <p className="text-stone-800" data-id="element-168">
                  <strong className="text-stone-900" data-id="element-169">Para quién es:</strong>{' '}
                  Para la persona que sabe qué comer pero no sabe cómo hacerlo
                  funcionar en el día a día real.
                </p>
              </div>
            </div>
          </motion.div>

          {/* BONO 2 */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={fadeIn} className="bg-white rounded-3xl overflow-hidden shadow-md border border-stone-200 flex flex-col" data-id="element-170">
            <div className="bg-stone-100 flex items-center justify-center p-8 md:p-12 border-b border-stone-200" data-id="element-171">
              <img src="https://cdn.magicpatterns.com/uploads/7N2NVGot3J3v4DrMXeqtzW/BONO_2.png" alt="Tracker Abdomen Calmado" className="w-full max-w-md object-contain drop-shadow-xl" data-id="element-172" />
            </div>
            <div className="p-8 md:p-10 flex flex-col justify-center" data-id="element-173">
              <div className="flex items-center gap-2 mb-4" data-id="element-174">
                <Gift className="w-5 h-5 text-emerald-600" data-id="element-175" />
                <span className="text-sm font-bold tracking-wider text-emerald-600 uppercase" data-id="element-176">
                  Bono #2
                </span>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-stone-900 mb-2" data-id="element-177">
                Tracker "Abdomen Calmado" (7 Días)
              </h3>
              <div className="flex items-center gap-3 mb-6 pb-6 border-b border-stone-100" data-id="element-178">
                <span className="text-stone-500 line-through" data-id="element-179">
                  Valor real: $50.000 ARS
                </span>
                <span className="bg-emerald-100 text-emerald-800 font-bold px-3 py-1 rounded-full text-sm" data-id="element-180">
                  Hoy: GRATIS
                </span>
              </div>

              <div className="space-y-4 text-stone-600 mb-8" data-id="element-181">
                <p data-id="element-182">
                  ¿Alguna vez sentiste que hacés todo "bien" y aún así te
                  hinchás?
                </p>
                <p data-id="element-183">
                  El problema no es la fuerza de voluntad. Es que no sabés qué
                  específicamente te está disparando la inflamación.
                </p>
                <p data-id="element-184">
                  ¿Es el estrés de los martes? ¿El poco sueño del domingo? ¿Esa
                  combinación de café y harinas que creés que está "bien"?
                </p>
                <p data-id="element-185">
                  El Tracker "Abdomen Calmado" te lo muestra en 7 días. No con
                  análisis complicados. No con apps que te piden macros y
                  calorías. Con escalas simples de 0 a 5 y 3 minutos por día de
                  registro.
                </p>
                <p data-id="element-186">
                  Al día 3, ya vas a ver un patrón. Al día 7, vas a saber
                  exactamente dónde está tu punto de fricción y qué cambiar
                  primero.
                </p>
              </div>

              <div className="mb-8" data-id="element-187">
                <h4 className="font-bold text-stone-900 mb-4 flex items-center gap-2" data-id="element-188">
                  <Target className="w-5 h-5 text-emerald-500" data-id="element-189" />
                  Lo que incluye:
                </h4>
                <ul className="space-y-3" data-id="element-190">
                  {['Registro diario 7 días (sueño / estrés / comidas / síntomas / abdomen)', 'Escalas simples 0–5 (sin tecnicismos)', 'Mini revisión al día 3 (ajustás 1 sola cosa)', "Mapa de disparadores: 'cuando pasa X, mi cuerpo hace Y'", '5 patrones comunes (para que te ubiques rápido)', 'Plan para la semana siguiente (qué mantenés / qué sacás / qué probás)', "Printable 'Resumen en 1 página' (para tener a mano)"].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-191">
                      <CheckCircle2 className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-192" />
                      <span className="text-stone-700" data-id="element-193">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="bg-stone-50 p-5 rounded-xl border border-stone-200" data-id="element-194">
                <p className="text-stone-800" data-id="element-195">
                  <strong className="text-stone-900" data-id="element-196">Para quién es:</strong>{' '}
                  Para quien ya probó "de todo" y necesita saber con precisión
                  qué le funciona y qué no, sin obsesionarse.
                </p>
              </div>
            </div>
          </motion.div>

          {/* BONO 3 */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={fadeIn} className="bg-white rounded-3xl overflow-hidden shadow-md border border-stone-200 flex flex-col" data-id="element-197">
            <div className="bg-stone-100 flex items-center justify-center p-8 md:p-12 border-b border-stone-200" data-id="element-198">
              <img src="https://cdn.magicpatterns.com/uploads/jBspbn36PyAtrPc48rdhcm/BONO_3.png" alt="Guía Café Sin Inflamar" className="w-full max-w-md object-contain drop-shadow-xl" data-id="element-199" />
            </div>
            <div className="p-8 md:p-10 flex flex-col justify-center" data-id="element-200">
              <div className="flex items-center gap-2 mb-4" data-id="element-201">
                <Gift className="w-5 h-5 text-emerald-600" data-id="element-202" />
                <span className="text-sm font-bold tracking-wider text-emerald-600 uppercase" data-id="element-203">
                  Bono #3
                </span>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-stone-900 mb-2" data-id="element-204">
                Guía "Café Sin Inflamar" (En 5 Reglas)
              </h3>
              <div className="flex items-center gap-3 mb-6 pb-6 border-b border-stone-100" data-id="element-205">
                <span className="text-stone-500 line-through" data-id="element-206">
                  Valor real: $50.000 ARS
                </span>
                <span className="bg-emerald-100 text-emerald-800 font-bold px-3 py-1 rounded-full text-sm" data-id="element-207">
                  Hoy: GRATIS
                </span>
              </div>

              <div className="space-y-4 text-stone-600 mb-8" data-id="element-208">
                <p data-id="element-209">
                  Una de las primeras preguntas que recibimos cuando alguien
                  empieza el protocolo es siempre la misma:{' '}
                  <em data-id="element-210">"¿Y el café? ¿Lo tengo que dejar?"</em>
                </p>
                <p data-id="element-211">
                  La respuesta corta: no. La respuesta larga: depende de cómo,
                  cuándo y con qué lo tomás.
                </p>
                <p data-id="element-212">
                  El café no es el enemigo. Pero tomado de cierta manera,
                  amplifica exactamente lo que querés bajar: el cortisol, la
                  sensibilidad digestiva y la retención de líquidos.
                </p>
                <p data-id="element-213">
                  La Guía "Café Sin Inflamar" te da 5 reglas claras para que el
                  café deje de ser un disparador y pase a ser una herramienta.
                  Sin dejarlo. Sin dramatizar. Sin elegir entre energía o
                  abdomen liviano.
                </p>
              </div>

              <div className="mb-8" data-id="element-214">
                <h4 className="font-bold text-stone-900 mb-4 flex items-center gap-2" data-id="element-215">
                  <Coffee className="w-5 h-5 text-emerald-500" data-id="element-216" />
                  Lo que incluye:
                </h4>
                <ul className="space-y-3" data-id="element-217">
                  {['Las 5 reglas exactas (horario / cantidad / combinaciones / agregados / recuperación)', 'Checklist de señales (cómo saber si el café te está inflando)', 'Tabla de swaps (qué cambiar sin perder el ritual)', 'Mini experimento 3 días (para encontrar TU versión ideal)', "Plantilla 'Mi café ideal' (para quedártela como referencia)", 'Plan de mantenimiento (80/20: sin extremismo, sin culpa)'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-218">
                      <CheckCircle2 className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-219" />
                      <span className="text-stone-700" data-id="element-220">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="bg-stone-50 p-5 rounded-xl border border-stone-200" data-id="element-221">
                <p className="text-stone-800" data-id="element-222">
                  <strong className="text-stone-900" data-id="element-223">Para quién es:</strong>{' '}
                  Para quien no está dispuesto a negociar el café pero sí está
                  dispuesto a tomarlo de una manera que no le arruine el
                  abdomen.
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Summary Table */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={fadeIn} className="max-w-3xl mx-auto bg-white rounded-3xl shadow-lg border border-stone-200 overflow-hidden" data-id="element-224">
          <div className="bg-stone-900 p-6 text-center" data-id="element-225">
            <h3 className="text-2xl font-bold text-white" data-id="element-226">
              Resumiendo lo que recibís hoy:
            </h3>
          </div>

          <div className="p-0" data-id="element-227">
            <table className="w-full text-left border-collapse" data-id="element-228">
              <thead data-id="element-229">
                <tr className="bg-stone-50 border-b border-stone-200" data-id="element-230">
                  <th className="p-4 md:p-6 font-bold text-stone-900 w-2/3" data-id="element-231">
                    Producto
                  </th>
                  <th className="p-4 md:p-6 font-bold text-stone-900 w-1/3 text-right" data-id="element-232">
                    Valor
                  </th>
                </tr>
              </thead>
              <tbody className="text-stone-700" data-id="element-233">
                <tr className="border-b border-stone-100" data-id="element-234">
                  <td className="p-4 md:p-6 flex items-center gap-3" data-id="element-235">
                    <CheckCircle2 className="w-5 h-5 text-emerald-500 shrink-0" data-id="element-236" />
                    <span data-id="element-237">
                      Protocolo Anti-Inflamación (Plan 30 días + Reset 72hs)
                    </span>
                  </td>
                  <td className="p-4 md:p-6 text-right font-medium" data-id="element-238">
                    $12.500 ARS
                  </td>
                </tr>
                <tr className="border-b border-stone-100 bg-stone-50/50" data-id="element-239">
                  <td className="p-4 md:p-6 flex items-center gap-3" data-id="element-240">
                    <Gift className="w-5 h-5 text-emerald-500 shrink-0" data-id="element-241" />
                    <span data-id="element-242">BONO #1: Menú Anti-Inflamación Express (15 Min)</span>
                  </td>
                  <td className="p-4 md:p-6 text-right" data-id="element-243">
                    <span className="line-through text-stone-400 text-sm block md:inline md:mr-2" data-id="element-244">
                      $50.000 ARS
                    </span>
                    <span className="text-emerald-600 font-bold" data-id="element-245">GRATIS</span>
                  </td>
                </tr>
                <tr className="border-b border-stone-100" data-id="element-246">
                  <td className="p-4 md:p-6 flex items-center gap-3" data-id="element-247">
                    <Gift className="w-5 h-5 text-emerald-500 shrink-0" data-id="element-248" />
                    <span data-id="element-249">BONO #2: Tracker "Abdomen Calmado" (7 Días)</span>
                  </td>
                  <td className="p-4 md:p-6 text-right" data-id="element-250">
                    <span className="line-through text-stone-400 text-sm block md:inline md:mr-2" data-id="element-251">
                      $50.000 ARS
                    </span>
                    <span className="text-emerald-600 font-bold" data-id="element-252">GRATIS</span>
                  </td>
                </tr>
                <tr className="border-b border-stone-200 bg-stone-50/50" data-id="element-253">
                  <td className="p-4 md:p-6 flex items-center gap-3" data-id="element-254">
                    <Gift className="w-5 h-5 text-emerald-500 shrink-0" data-id="element-255" />
                    <span data-id="element-256">BONO #3: Guía "Café Sin Inflamar" (En 5 Reglas)</span>
                  </td>
                  <td className="p-4 md:p-6 text-right" data-id="element-257">
                    <span className="line-through text-stone-400 text-sm block md:inline md:mr-2" data-id="element-258">
                      $50.000 ARS
                    </span>
                    <span className="text-emerald-600 font-bold" data-id="element-259">GRATIS</span>
                  </td>
                </tr>
                <tr className="border-b border-stone-200" data-id="element-260">
                  <td className="p-4 md:p-6 font-bold text-stone-900" data-id="element-261">
                    VALOR TOTAL
                  </td>
                  <td className="p-4 md:p-6 text-right font-bold text-stone-500 line-through text-lg" data-id="element-262">
                    $162.500 ARS
                  </td>
                </tr>
                <tr className="bg-emerald-50" data-id="element-263">
                  <td className="p-6 md:p-8 font-black text-emerald-900 text-xl md:text-2xl flex items-center gap-2" data-id="element-264">
                    <ArrowRight className="w-6 h-6 text-emerald-600" data-id="element-265" />
                    TU INVERSIÓN HOY
                  </td>
                  <td className="p-6 md:p-8 text-right font-black text-emerald-600 text-2xl md:text-3xl" data-id="element-266">
                    $12.500 ARS
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </motion.div>
      </div>
    </section>;
}